<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="productionrouting_keyno" [ttModel]="edit.productionrouting_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="productionroutinglang_name" [(ttModel)]="edit.productionroutinglang_name" ttRequired></tt-input>
        <tt-button-save ttText="productionrouting_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="productionrouting_keyno" tt-model="vm.model.edit.productionrouting_keyno" tt-change="vm.model.edit.productionrouting_keyno = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="productionroutinglang_name" tt-model="vm.model.edit.productionroutinglang_name" tt-change="vm.model.edit.productionroutinglang_name = $value" tt-readonly="false"></tt-input>
        <tt-button-save class="col-xs-12 sp-0" tt-text="productionrouting_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
